import service from '@/store/services/tax-offices-service';

const state = {
    list: {},
    taxOffice: {},
    meta: {},
    url: null
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, taxOffice) => {
        state.taxOffice = taxOffice;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    }
};

const actions = {
    list({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get({ commit, dispatch }, params) {
        return service.get(params)
            .then((taxOffice) => { commit('SET_RESOURCE', taxOffice); });
    },

    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((taxOffice) => { commit('SET_RESOURCE', taxOffice); });
    },

    update({ commit, dispatch }, params) {
        return service.update(params)
            .then((taxOffice) => { commit('SET_RESOURCE', taxOffice); });
    },

    destroy({ commit, dispatch }, params) {
        return service.destroy(params);
    }
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    taxOffice: state => state.taxOffice,
    dropdown: (state) => {
        return state.list.map(taxOffice => ({
            code: taxOffice.code,
            name: taxOffice.name
        }));
    },
    url: state => state.url
};

const taxOffices = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default taxOffices;